<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">New Claims Advice</h1>
      </template>
      <template #actions>
        <page-header-action @click.prevent="toggleNotes">
          Notes
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <form-navigation-tabs
          :tabs="tabs"
          v-on:selected="setActive"
          :simple="true"
          :active="currentView"
        ></form-navigation-tabs>
      </div>
    </div>
    <div v-show="currentView == 'new_claims_advice'">
      <div class="row">
        <div class="col-lg-12">
          <div class="card mb-3">
            <div class="card-body" v-if="currentStep.step">
              <h2 class="text-center" v-text="currentStep.step.body"></h2>
              <div class="fields" v-if="currentStep.form">
                <div
                  class="field"
                  v-bind:key="index"
                  v-for="(field, index) in currentStep.form.fields"
                >
                  <label
                    :for="field.name"
                    class="control-label"
                    v-text="field.label"
                  ></label>
                  <div v-if="field.type.name == 'multi-selectlist'">
                    <multiselect
                      :options="field.options"
                      track-by="id"
                      :multiple="true"
                      label="label"
                      v-model="field.value"
                    ></multiselect>
                  </div>
                  <div v-if="field.type.name == 'selectlist'">
                    <selectlist
                      :name="field.name"
                      :stacked="true"
                      v-model="field.value"
                      key-name="name"
                      :options="field.options"
                    ></selectlist>
                  </div>
                  <div v-if="field.type.name == 'text'">
                    <inputbox
                      :name="field.name"
                      :stacked="true"
                      v-model="field.value"
                    ></inputbox>
                  </div>
                  <div
                    v-if="field.type.name == 'date-time-picker'"
                    style="margin-bottom:15px;"
                  >
                    <datetimepicker
                      :name="field.name"
                      :stacked="true"
                      v-model="field.value"
                      input-class="form-control"
                    ></datetimepicker>
                  </div>
                  <div v-if="field.type.name == 'textarea'">
                    <input-block
                      :name="field.name"
                      :stacked="true"
                      v-model="field.value"
                    ></input-block>
                  </div>
                </div>
              </div>
              <div class="buttons">
                <form-button
                  v-if="currentStep.form"
                  :indicator="completingForm"
                  v-on:clicked="completeForm(currentStep)"
                  >Continue</form-button
                >
                <form-button
                  :indicator="completingAction"
                  v-for="action in currentStep.actions"
                  :key="action.identifier"
                  v-on:clicked="actionClicked(action, currentStep)"
                  >{{ action.action.body }}</form-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <incident-details
      :incident="incident"
      v-show="currentView == 'incident_details'"
    ></incident-details>
    <notes-window
      :show="notes"
      :incident="incident"
      v-on:toggle-note="toggleNotes"
    ></notes-window>
  </div>
</template>

<script>
import Notes from './../Shared/Notes.vue';
import IncidentDetails from './../Shared/IncidentDetails.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'notes-window': Notes,
    'incident-details': IncidentDetails
  },

  data() {
    return {
      completingForm: false,
      completingAction: false,
      notes: false,
      currentStep: {},
      new_claims_advice: null,
      completed: false,
      currentView: 'new_claims_advice',
      tabs: [
        {
          name: 'new_claims_advice',
          label: 'New Claims Advice'
        },
        {
          name: 'incident_details',
          label: 'Incident Details'
        }
      ]
    };
  },

  mounted() {
    window.Ajax.get('/new-claims-advice/' + this.incident)
      .then(response => {
        this.new_claims_advice = response.data.identifier;

        window.Ajax.get(
          '/new-claims-advice/' +
            this.incident +
            '/steps/' +
            this.new_claims_advice
        )
          .then(response => {
            if (response.data === 'Completed') {
              this.sendToEmail();
            }

            this.currentStep = response.data;

            if (!response.data.actions.length && response.data.form === null) {
              this.completed = true;
            }
          })
          .catch(error => {});
      })
      .catch(error => {});
  },

  methods: {
    sendToEmail() {
      this.route(`/new-claims-advice/${this.incident}/email`);
    },

    setActive(tab) {
      this.currentView = tab;
    },

    viewIncidentDetails() {
      this.$router.push('/new-claims-advice/' + this.incident + '/details');
    },

    completeForm(step) {
      this.completingForm = true;
      window.Ajax.post(
        '/new-claims-advice/' +
          this.incident +
          '/steps/' +
          this.new_claims_advice +
          '/form',
        {
          fields: step.form.fields,
          step: step.identifier,
          form: step.form.identifier
        }
      )
        .then(response => {
          this.completingForm = false;
          this.currentStep = response.data;
        })
        .catch(error => {
          this.completingForm = false;
        });
    },

    actionClicked(action, step) {
      if (action.url && action.new_window) {
        window.open(
          action.url + '?token=' + window.window.Token.get(),
          '_blank'
        );
        return;
      }
      this.completingAction = true;
      window.Ajax.post(
        '/new-claims-advice/' +
          this.incident +
          '/steps/' +
          this.new_claims_advice,
        {
          action: action.identifier,
          step: step.identifier
        }
      )
        .then(response => {
          this.completingAction = false;
          if (response.data === 'Completed') {
            this.sendToEmail();
          }

          this.currentStep = response.data;

          if (!response.data.actions.length && response.data.form === null) {
            this.completed = true;
          }
        })
        .catch(error => {
          this.completingAction = false;
        });
    },

    toggleNotes() {
      this.notes = !this.notes;
    }
  }
};
</script>
